module.exports = __webpack_public_path__ + "static/media/Aelfar.e4612560.md";